import React from 'react';
import { LayoutDashboard, Users, ShoppingBag, CreditCard, Box, MessageSquare, Settings } from 'lucide-react';

interface MobileNavProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

/**
 * 移动端底部标签栏（LG-移动端适配）
 * 仅 <768px（md 断点以下）显示；复用 App 的 activeTab / setActiveTab，不引入新状态。
 * 桌面端由 Sidebar 承担导航，本组件通过 `md:hidden` 自动隐藏。
 */
const MobileNav: React.FC<MobileNavProps> = ({ activeTab, setActiveTab }) => {
  const menuItems = [
    { id: 'dashboard', icon: LayoutDashboard, label: '仪表盘' },
    { id: 'accounts', icon: Users, label: '账号' },
    { id: 'orders', icon: ShoppingBag, label: '订单' },
    { id: 'cards', icon: CreditCard, label: '卡密' },
    { id: 'items', icon: Box, label: '商品' },
    { id: 'keywords', icon: MessageSquare, label: '关键词' },
    { id: 'settings', icon: Settings, label: '设置' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 md:hidden flex items-stretch justify-around bg-white/95 backdrop-blur border-t border-gray-100 pb-[env(safe-area-inset-bottom)]">
      {menuItems.map((item) => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`flex-1 min-h-[52px] flex flex-col items-center justify-center gap-0.5 transition-colors duration-200 ${
              isActive ? 'text-black' : 'text-gray-400'
            }`}
          >
            <span
              className={`flex items-center justify-center w-10 h-7 rounded-xl transition-colors ${
                isActive ? 'bg-[#FFE815]' : ''
              }`}
            >
              <Icon className="w-5 h-5" />
            </span>
            <span className="text-[10px] font-medium leading-none tracking-wide">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileNav;
